import { render } from "./SelectableUpsells.vue?vue&type=template&id=32c0482c&scoped=true"
import script from "./SelectableUpsells.vue?vue&type=script&lang=js"
export * from "./SelectableUpsells.vue?vue&type=script&lang=js"

import "./SelectableUpsells.vue?vue&type=style&index=0&id=32c0482c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c0482c"]])

export default __exports__